import * as React from 'react';

import { TgbBannerContainer } from '../../Banners';
import { MobileLayout } from '../../../components/MobileLayout';
import { FullscreenGalleryContainer } from '../../FullscreenGallery';
import { NewbuildingImageMobileContainer } from '../../NewbuildingImageMobile';
import { NewbuildingInfoMobileContainer } from '../../NewbuildingInfo';
import { ShowContactsLayoutContainer } from '../../ShowContactsLayout';
import { GalleryContainer } from '../../Gallery';
import { LoadMoreButtonContainer } from '../../LoadMoreButton';

export const MobileViewContainer: React.FC = () => {
  return (
    <>
      <NewbuildingImageMobileContainer />
      <MobileLayout
        newbuildingInfo={<NewbuildingInfoMobileContainer />}
        gallery={<GalleryContainer />}
        loadMoreButton={<LoadMoreButtonContainer />}
        banner={<TgbBannerContainer type="listing" />}
        actionButton={<ShowContactsLayoutContainer />}
      />
      <FullscreenGalleryContainer />
    </>
  );
};
